(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bloc-payment-line"] && !Shopify.designMode) return;
  try {
    (function(){
    function bind(){
      document.querySelectorAll('.payline[data-scroll="true"]').forEach(function(el){
        if(el.dataset.plBound) return; el.dataset.plBound='1';
        el.addEventListener('click', function(){
          var sel = el.getAttribute('data-target') || 'form[action*="/cart/add"]';
          var off = parseInt(el.getAttribute('data-offset')||'0',10);
          var t = document.querySelector(sel);
          if(!t) return;
          var y = t.getBoundingClientRect().top + window.pageYOffset - off;
          window.scrollTo({ top:y, behavior:'smooth' });
        });
      });
    }
    bind();
    document.addEventListener('shopify:section:load', bind);
  })();
  } catch(e) { console.error(e); }
})();

})();
